import React, { useContext, useEffect, useState } from 'react';
import { UtagContext } from '../../context/UtagContext';
import { Spinner } from '../../components/spinner';
import { useTranslation } from 'react-i18next';
import { useTitle } from '../../hooks/useTitle';
import PartDisplayOption from '../part-display-option';
import './TopSearch.scss';
import { callGTMAnalytics } from '../../helper/analyticsTag';
import { IUtag } from '../../models/IUtag';
interface IProps {
  inputError: string;
  isFetching: boolean;
  searchText: string;
  isActiveChecked: boolean;
  isMarketplaceChecked: boolean;
  isExcludeTariffChecked: boolean;
  isStockingChecked: boolean;
  isTariffActive: boolean;
  isTabCompareAtt: boolean;
  isHasMyList: boolean;

  onSearchClick: (searchQuery: string) => void;
  onApplyActive: (isActivePartInclude: boolean) => void;
  onApplyMarketplace: (isMarketplaceInclude: boolean) => void;
  onApplyExcludeTariff: (isExcludeTariff: boolean) => void;
  onApplyStocking: (isStockingInclude: boolean) => void;
}

const TopSearch: React.FC<IProps> = (props) => {
  const utagContext = useContext(UtagContext);

  const {
    inputError,
    isFetching,
    searchText,
    isActiveChecked,
    isMarketplaceChecked,
    isExcludeTariffChecked,
    isStockingChecked,
    isTariffActive,
    isTabCompareAtt,
    isHasMyList,
    onSearchClick,
    onApplyActive,
    onApplyMarketplace,
    onApplyExcludeTariff,
    onApplyStocking
  } = props;
  const [searchValue, setSearchValue] = useState<string>('');

  const { t } = useTranslation();

  const handleChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const onSearchHandler = (event: React.FormEvent) => {
    event.preventDefault();
    let searchbtn =
      document
        .querySelector('#xref-search-btn')
        ?.getAttribute('ref_page_event') ?? '';
    if (searchbtn) {
      utagContext.setRef(searchbtn);
    }

    setSearchValue(searchValue.trim().toUpperCase());
    onSearchClick(searchValue.trim());
  };

  const onExamplePartClick = (e: any) => {
    let examplePart =
      document
        .querySelectorAll('.dk-link.example_part')[0]
        ?.getAttribute('ref_page_event') ?? '';
    if (examplePart) {
      utagContext.setRef(examplePart);
      callGTMAnalytics({} as IUtag, examplePart);
    }
    onSearchClick(e.target.textContent);
    setSearchValue(e.target.textContent);
  };

  useEffect(() => {
    if (searchText) {
      setSearchValue(searchText);
    }
  }, [searchText]);

  const title = t('xref-seo-title');
  useTitle(title, searchText, inputError);
  return (
    <>
      <div id="top-intro">
        {isHasMyList ? (
          <p> {t('xref-has-my-list-info')}</p>
        ) : (
          <p>
            {t('xref-search-ctr-use-this-tool')} {t('xref-see-examples')}{' '}
            <button
              className="dk-link example_part"
              onClick={onExamplePartClick}
              {...{ ref_page_event: 'See Example' }}
            >
              LM358M/NOPB
            </button>
            ,{' '}
            <button
              className="dk-link example_part"
              onClick={onExamplePartClick}
              {...{ ref_page_event: 'See Example' }}
            >
              NCP551SN33T1G
            </button>{' '}
            {t('xref-or')}{' '}
            <button
              className="dk-link example_part"
              onClick={onExamplePartClick}
              {...{ ref_page_event: 'See Example' }}
            >
              B37872K9105K62
            </button>
          </p>)}
      </div>
      <div id="top-search">
        <form
          onSubmit={onSearchHandler}
          data-testid="search-submit"
          className="form-search"
        >
          <div id="input-search" className={isHasMyList ? "disabled" : ""}>
            <div id="searchInput" className="dk-input-group">
              <input
                id=""
                className={`dk-input ${inputError ? 'dk-input--error' : ''}`}
                value={searchValue}
                onChange={handleChangeHandler}
                placeholder={t('xref-enter-complete-mfr-part-number')}
                onInput={handleChangeHandler}
                data-testid="test-search-input"
              />
            </div>
            <button
              className={`dk-btn__primary top-search__button ${isHasMyList ? "disabled" : ""}`}
              type="submit"
              id="xref-search-btn"
              data-testid="test-search-submit-button"
              {...{ ref_page_event: 'Search for Part' }}
              style={{ marginBottom: inputError ? '27px' : '10px' }}
            >
              {(isFetching && !isHasMyList) ? <Spinner /> : t('xref-search')}
            </button>
          </div>
        </form>
      </div>
      {searchText && (
        <div id="top-numberOfResults">
          <PartDisplayOption
            onApplyActive={onApplyActive}
            onApplyMarketplace={onApplyMarketplace}
            onApplyExcludeTariff={onApplyExcludeTariff}
            onApplyStocking={onApplyStocking}
            isActiveChecked={isActiveChecked}
            isMarketplaceChecked={isMarketplaceChecked}
            isStockingChecked={isStockingChecked}
            isExcludeTariffChecked={isExcludeTariffChecked}
            isTariffActive={isTariffActive}
            isTabCompareAtt={isTabCompareAtt}
          ></PartDisplayOption>
        </div>
      )}
    </>
  );
};

export default TopSearch;
